<template lang="pug">
.v-cropp-image.cropp-image(v-if="data" :class="data.className")
	h1 {{ data.title }}
	.cropp-image__content
		.cropper-area
			.img-cropper
				vue-cropper(
					ref="cropper"
					:src="data.image"
					:aspect-ratio="data.className === 'logo' ? null : 1"
					:view-mode="1"
					preview=".preview")
		.preview-area
			.preview
	.actions
		a(href="#" role="button" @click.prevent="cropImage") {{ data.saveButton }}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import 'cropperjs/dist/cropper.css';
import controller from "../scripts/controller/controller.js";
export default {
	mixins: [
		sourceMixin,
	],

	data() {
		return {
			cropImg: '',
			data: null,
			params: null
		};
	},

	methods: {
		dataSet(data) {
			this.data = data;
			this.setData()
		},

		setData() {
			if (!this.data.croppParams) return;
			this.$nextTick(()=> {
				if(this.$refs.cropper) {
					this.$refs.cropper.setData(JSON.parse(this.data.croppParams));
				}
			})
		},

		getData() {
			this.params = JSON.stringify(this.$refs.cropper.getData(), null, 4);
		},

		cropImage() {
			this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
			this.getData()
			controller.closeModal();
			const data = {
				img: this.cropImg,
				params: this.params
			}
			this.$emit('setCroppedImage', data);
		},

	},

};
</script>